(ns common.schema.entities.workspace.kyc.templates.demo.pep
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def schema
  {:kyc-template/template-name
   "PEP"
   :kyc-template/kyc-form-preface
   {:translations {:en "Politically Exposed Persons (PEP)"
                   :fi "Poliittisesti vaikutusvaltaiset henkilöt"}}
   :kyc-pep.group/basic-information
   {:ord          1.0
    :translations {:en "PEP information"
                   :fi "Henkilön tiedot"}
    :info
    {:en ""
     :fi
     (str
      "<p><strong>Poliittisesti vaikutusvaltainen henkilö (“PEP”)</strong> "
      "toimii tai on toiminut merkittävässä julkisessa virassa (A), kuuluu tai on kuulunut sellaisen henkilön lähipiiriin (B) tai on tai on ollut sellaisen henkilön läheinen (C), Suomessa tai toisessa valtiossa viimeisen 12 kuukauden aikana:</p>"
      "<p><strong>A) Merkittävänä poliittisena virkana pidetään seuraavia virkoja:</strong>"
      "<ul><li>Valtion- tai hallituksen päämies, ministeri, vara-tai apulaisministeri;</li>"
      "<li>Parlamentin jäsen;</li>"
      "<li>Korkeimman oikeuden, perustuslakituomioistuimen tai muun vastaavan oikeuselimen jäsen;</li>"
      "<li>Keskuspankin johtokunnan jäsen;</li>"
      "<li>Suurlähettiläs;</li>"
      "<li>Puolustusvoimien kenraalikuntaan kuuluva upseeri;</li>"
      "<li>Valtionyritysten hallinto-, johto- ja valvontaelimen jäsen;</li>"
      "<li>EU-parlamentin jäsen;</li>"
      "<li>Komission jäsen;</li>"
      "<li>EU-tuomioistuimen jäsen</li>"
      "<li>EU:n tilintarkastustuomioistuimen jäsen</li>"
      "<li>Member of the EU Court of Auditors</li></ul></p>"
      "<p><strong>(B) Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
      "<ul><li>luonnollinen henkilö,joka toimii poliittisesti vaikutusvaltaisen henkilön yhtiökumppanina;</li>"
      "<li>luonnollinen hekilö, jonka omistaman yhtiön tosiasiallisena edunsaajana on poliittisesti vaikutusvaltainen henkilö.</li></ul></p>"
      "<p><strong>(C) Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
      "<ul><li>(i) poliittisesti vaikutusvaltaisen henkilön puoliso tai puolisoon kansallisen lain mukaisesti rinnastettava kumppani;</li>"
      "<li>(ii) poliittisesti vaikutusvaltaisen henkilön lapset sekä heidän puolisonsa kohdan (i) mukaisesti;</li>"
      "<li>(iii) poliittisesti vaikutusvaltaisen henkilön vanhemmat.</li></ul></p>")}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo.pep/name]
                    [:kyc-ubo.pep/connection-to-investor]
                    [:kyc-ubo.pep/relationship-to-pep]
                    [:kyc-ubo.pep/related-person-name]
                    [:kyc-ubo.pep/country]
                    [:kyc-ubo.pep/political-function]
                    [:kyc-ubo.pep/dob]
                    [:kyc-ubo.pep/birth-country]])}})
